/**
* @file client-entry.js
* @description Entry point for Rspack build process
* --------------------------------------------------------------------------
* 🔌 Rspack Client Entry (Development)
* --------------------------------------------------------------------------
* • [■ client-entry.js ] ──▶ [   client-rspack.js ] ──▶ [   client-meteor.js ]
*
* This file is the entry point that Rspack uses to start the build process.
* It imports the module defined in `meteor.mainModule.client` inside package.json.
* From here, Rspack can trace the entire dependency graph of your application
* and generate the bundled output (`client-rspack.js`).
*
* ⚠️ Note: This file is autogenerated. It is not meant to be modified manually.
* These files also act as a cache: they can be safely removed and will be
* regenerated on the next build. They should be ignored in IDE suggestions
* and version control.
*/

/* Enables HMR */
if (module.hot) {
  module.hot.accept();
}

/* Link to 🔌 Meteor Client Entry */
import '../../client/main.tsx';
